import { API_ENDPOINT, API_URL } from "@/api/constant";
import Button from "../Button";
import CommonModal from "../CommonModal";
import { callApi, ThrowError } from "@/api/callApi";
import { useState } from "react";
import { logoutUser, showToastNotification } from "@/utility/helper";


export const LogoutModel: React.FC<{ showLogoutModal: boolean; setShowLogoutModal: (value: boolean) => void; }> = ({ showLogoutModal, setShowLogoutModal }) => {
    const [isLoggingOut, setIsLoggingOut] = useState<boolean>(false);
    const handleLogout = async () => {
        setIsLoggingOut(true);
        try {
            const deviceId = localStorage.getItem('deviceId') ?? '';
            await callApi(
                `${API_URL}${API_ENDPOINT.auth}/logout?deviceId=${deviceId}`,
                {
                    method: 'DELETE',
                },
            );
            showToastNotification('success', 'Logged out successfully');
        } catch (error) {
            ThrowError(error);
        } finally {
            setIsLoggingOut(false);
            setShowLogoutModal(false);
            logoutUser();
        }
    };
    return (
        <CommonModal
            open={showLogoutModal}
            size="sm"
            onOpenChange={setShowLogoutModal}
            title="Confirm Logout"
        >
            <div className="space-y-4">
                <p className="text-sm text-muted-foreground">
                    Are you sure you want to logout? You will need to sign in again to access the dashboard.
                </p>
                <div className="flex justify-end gap-2">
                    <Button
                        type="button"
                        disabled={isLoggingOut}
                        onClick={() => setShowLogoutModal(false)}
                        variant="outline"
                        size="sm"
                        className="cursor-pointer"
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        variant="destructive"
                        isLoading={isLoggingOut}
                        loadingText="Logging out..."
                        onClick={handleLogout}
                        size="sm"
                        className="cursor-pointer"
                    >
                        Yes, Logout
                    </Button>
                </div>
            </div>
        </CommonModal>
    )
}